import * as React from 'react';

import * as styles from './ProjectsList.css';
import { ProjectItem, TEditData } from './ProjectItem';
import { TProject } from 'shared/types/project';
import { UIText2 } from '@cian/ui-kit';

interface IProjectsListProps {
  projects: TProject[];
  currentUrl: string;
  onProjectClick: (id: number) => void;
  onProjectEditClick: (data: TEditData) => void;
}

export const ProjectsList: React.FC<IProjectsListProps> = ({
  projects,
  currentUrl,
  onProjectClick,
  onProjectEditClick,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <UIText2>Опубликован</UIText2>
        <UIText2>Название</UIText2>
        <UIText2>Создан</UIText2>
        <UIText2>Обновлен</UIText2>
        <UIText2>Дата макета</UIText2>
        <UIText2>Хэш</UIText2>
        <UIText2>Действия</UIText2>
      </div>
      <ul className={styles['list']}>
        {projects.map(project => (
          <ProjectItem
            key={project.id}
            {...project}
            onClick={onProjectClick}
            onEditClick={onProjectEditClick}
            currentUrl={currentUrl}
          />
        ))}
      </ul>
    </div>
  );
};
